import { PERMISSIONS } from './permissions';

/**
 * What the Mine Setup Wizard writes: the site, its levels, zones, tunnels and
 * teams, the first production target, and the call that marks the setup done.
 * The wizard reads the site list before it starts, so that is here too.
 *
 * The backend keeps the same list (`mine-setup-permissions.ts`) to decide
 * whether to send someone to the wizard at login. This one decides whether the
 * page opens, and whether a redirect to it is followed, so a manager missing a
 * key is never held on a screen whose every save is refused.
 */
export const MINE_SETUP_PERMISSIONS: string[] = [
  PERMISSIONS.SITE_VIEW,
  PERMISSIONS.SITE_CREATE,
  PERMISSIONS.SITE_EDIT,
  PERMISSIONS.LEVEL_CREATE,
  PERMISSIONS.ZONE_CREATE,
  PERMISSIONS.TUNNEL_CREATE_ITEM,
  PERMISSIONS.TEAM_CREATE,
  PERMISSIONS.PRODUCTION_TARGET_CREATE,
  PERMISSIONS.PROFILE_COMPLETE_SETUP,
];
